import ColorParser from '@af-common/Common/Utils/ColorParser';
import ModuleCircleStore from '../Module/ModuleCircle/_stores/ModuleCircleStore';
import ModuleRectangleStore from '../Module/ModuleRectangle/_stores/ModuleRectangleStore';
import ModulePolygonStore from '../Module/ModulePolygon/_stores/ModulePolygonStore';
import { ModuleAction } from '../Module/_actions/ModuleActions';
import { ModuleTypes } from '../Module/_config/ModuleInfo';
import ModuleStore from '../Module/_stores/ModuleStore';
import CircleShader from "../Webgl/Shader/CircleShader";
import RectangleShader from "../Webgl/Shader/RectangleShader";
import PolygonShader from "../Webgl/Shader/PolygonShader";
import * as Uniform from "../Webgl/Uniform";
import Webgl from '../Webgl/Webgl';
import CanvasWrapper from '../Webgl/CanvasWrapper';
import { IHandler } from './ModuleHandler';

export default class ShapeHandler implements IHandler {
	public getOutput(module: ModuleStore, webgl: Webgl, documentWidth:number, documentHeight:number, quality:number, useChunks:boolean, updater: (key:string, value:any) => ModuleAction) {
		let store:any = undefined;

		let fbo = webgl.fbos[webgl.currentFramebuffer];

		let inputSizeWidth:number = fbo.width * (100 / quality);
		let inputSizeHeight:number = fbo.height * (100 / quality);

		switch(module.get('type')) {
			case ModuleTypes.Circle:
				store = module as ModuleCircleStore;
				
				let radius = store.get('radius');
				if(!radius) return;

				if(!webgl.programs["circle"]) webgl.createProgram('circle', new CircleShader());

				let circleShader:CircleShader = webgl.programs["circle"].shader as CircleShader;

				webgl.useProgram("circle");

				circleShader.u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				circleShader.u_inputSize = new Uniform.Uniform2f(inputSizeWidth, inputSizeHeight);
				circleShader.u_translation = new Uniform.Uniform2f(store.get("x"), store.get("y"));
				circleShader.u_radius = new Uniform.Uniform1f(store.get('radius'));
				circleShader.u_color = ColorParser.stringToUniform(store.get('color'));
				break;
			case ModuleTypes.Rectangle:
				store = module as ModuleRectangleStore;
				
				let width = store.get("width");
				let height = store.get("height");

				if(!(width&&height)) return;

				if(!webgl.programs["rectangle"]) webgl.createProgram('rectangle', new RectangleShader());

				let rectangleShader:RectangleShader = webgl.programs["rectangle"].shader as RectangleShader;

				webgl.useProgram("rectangle");

				rectangleShader.u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				rectangleShader.u_inputSize = new Uniform.Uniform2f(inputSizeWidth, inputSizeHeight);
				rectangleShader.u_translation = new Uniform.Uniform2f(store.get("x"), store.get("y"));
				rectangleShader.u_size = new Uniform.Uniform2f(store.get('width'), store.get('height'));
				rectangleShader.u_rotation = new Uniform.Uniform1f(store.get("rotation") / (180/Math.PI));
				rectangleShader.u_color = ColorParser.stringToUniform(store.get('color'));
				break;
			case ModuleTypes.Polygon:
				store = module as ModulePolygonStore;
				
				if(!webgl.programs["polygon"]) webgl.createProgram('polygon', new PolygonShader());

				let polygonShader:PolygonShader = webgl.programs["polygon"].shader as PolygonShader;

				webgl.useProgram("polygon");

				polygonShader.u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				polygonShader.u_inputSize = new Uniform.Uniform2f(inputSizeWidth, inputSizeHeight);
				polygonShader.u_translation = new Uniform.Uniform2f(store.get("x"), store.get("y"));
				polygonShader.u_radius = new Uniform.Uniform1f(store.get('radius'));
				polygonShader.u_rotation = new Uniform.Uniform1f(store.get('rotation') / (180/Math.PI));
				polygonShader.u_sides = new Uniform.Uniform1i(store.get('sides'));
				polygonShader.u_color = ColorParser.stringToUniform(store.get('color'));
				break;
		}

		webgl.render();
	}
}